import React, { PureComponent } from 'react';

import Html from 'components/Html';
import { ToggleCard } from 'components/toggleCard';
import { translate } from 'components/translate';
import get from 'lodash/get';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import PropTypes from 'prop-types';

import SalesManagerEvents from '../../../SalesManagerEvents';

@translate()
class SalesInfoFreeSignUp extends PureComponent {
  static propTypes = {
    t: PropTypes.func,
    checked: PropTypes.bool,
    onChange: PropTypes.func
  };

  labelPath = 'sales_manager.sales_info.free_signup';

  constructor(props) {
    super(props);

    const { t } = props;

    this.toggleProps = {
      label: {
        on: t('general.yes'),
        off: t('general.no')
      },
      onChange: this.handleChange
    };
  }

  handleChange = (event) => {
    const { onChange } = this.props;
    const checked = get(event, 'target.checked', null);

    checked !== null && SalesManagerEvents.freeSignUpToggle(checked);

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.SALES_SECTION,
        action: checked
          ? EVENTS_INTERACTIONS.TOGGLE_ON
          : EVENTS_INTERACTIONS.TOGGLE_OFF,
        label: EVENTS_LABELS.SALES_SECTION.FREE_SIGN_UP
      })
    });

    onChange && onChange(event);
  };

  renderDescription = () => (
    <Html
      tag="p"
      className="sales_info__description"
      data-test="grid-description"
    >
      {this.props.t(`${this.labelPath}.description`)}
    </Html>
  );

  render() {
    const { t, checked } = this.props;

    return (
      <ToggleCard
        title={t('general.free_signup')}
        description={this.renderDescription()}
        label={t(`${this.labelPath}.toggle`)}
        checked={checked}
        toggleProps={this.toggleProps}
      />
    );
  }
}

export default SalesInfoFreeSignUp;
